'use strict';

window.getScrollTopElement = function() {
    var html = document.documentElement,
        body = document.body,
        startingY = window.pageYOffset || body.scrollTop || html.scrollTop,
        newY = startingY + 1;

    window.scrollTo(0, newY);

    //Check which property changed to detect global scrolling element
    // FF and IE use only html. Safari uses only body.
    // Chrome has values for both, but says
    // body.scrollTop is deprecated when in Strict mode.,
    // so let's check for html first.
    var element = (html.scrollTop === newY) ? 'html' : 'body';

    //Reset
    window.scrollTo(0, startingY);

    return element;
};

module.exports = function() {
    var $navContainer = $("#nav-container");
    var navHeight = 100; //nav height

    $(window).scroll(function(evt) {
        if ($(this).scrollTop() > 5) {
            $navContainer.addClass('stick');
        } else {
            $navContainer.removeClass('stick');
        }
    });

    $("body").on('click', '.scroll-btn', function(evt) {
        var $scrollToElem = $(this.hash);

        if (!$scrollToElem.length) {
            return;
        }

        var speed = Math.abs(window.scrollY - $scrollToElem.offset().top - navHeight) * .7;

        evt.preventDefault();

        $(window.getScrollTopElement()).animate({
            scrollTop: $scrollToElem.offset().top - navHeight
        }, speed);

        window.history.replaceState(null, '', this.hash);
    });
};



// WEBPACK FOOTER //
// ./resources/js/components/navScroll.js